module.exports = __webpack_public_path__ + "static/img/aa-1.8d6ced8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa-1.png
// module id = WOtH
// module chunks = 1